// Refined motion tokens — slower, calmer, luxury-brand cadence.
// Parent Maklan uses ~1.2–1.4s reveals with an expo-out curve.
export const EASE_PREMIUM = [0.19, 1, 0.22, 1];   // expo out — calm and confident
export const EASE_SMOOTH  = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show:   { opacity: 1, y: 0, transition: { duration: 1.2, ease: EASE_PREMIUM } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show:   { opacity: 1, transition: { duration: 1.1, ease: EASE_PREMIUM } },
};

export const stagger = (delay = 0.1) => ({
  hidden: {},
  show:   { transition: { staggerChildren: delay, delayChildren: 0.15 } },
});

// Masked line reveal — slower with a small stagger for editorial cadence.
export const maskReveal = {
  hidden: { y: "115%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 1.3, ease: EASE_PREMIUM, delay: 0.2 + i * 0.09 },
  }),
};
